import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetTakeOffOrderDTO from "../../../models/DTO/IGetTakeOffOrderDTO";
import IOnDeleteCategoryDTO from "../../../models/DTO/IOnDeleteCategoryDTO";
import IOnGetTakeOffOrderDTO from "../../../models/DTO/IOnGetTakeOffOrderDTO";
import IOnProcessTakeOffOrderCategoryDTO from "../../../models/DTO/IOnProcessTakeOffOrderCategoryDTO";
import IOnUpdateCategoryDTO from "../../../models/DTO/IOnUpdateCategoryDTO";
import IProcessTakeOffOrderCategoryDTO from "../../../models/DTO/IProcessTakeOffOrderCategoryDTO";
import IUpdateCategoryDTO from "../../../models/DTO/IUpdateCategoryDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICategory from "../../../models/ICategory";
import INewCategory from "../../../models/INewCategory";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import CategoryAccordion from "../../catalogs/CatalogOverview/CategorySidebar/CategoryAccordion/CategoryAccordion";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./TakeOffOrderCategorySidebar.scss";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    takeOffOrder: IOrder;
    takeOffCategories: ICategory[];
};

type State = {
    createActive: boolean;
    name: string;
    takeOffCategories: ICategory[];
};

class TakeOffOrderCategorySidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            name: "",
            takeOffCategories: this.props.takeOffCategories,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.TakeOffOnGetTakeOffOrder, this.onGetTakeOffOrder);
        this.props.socket.on(EndpointsEnum.TakeOffOnProcessTakeOffOrderCategory, this.onProcessTakeOffOrderCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
        this.props.socket.on(EndpointsEnum.CategoriesOnDeleteCategory, this.onDeleteCategory);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnGetTakeOffOrder, this.onGetTakeOffOrder);
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnProcessTakeOffOrderCategory, this.onProcessTakeOffOrderCategory);
        this.props.socket.removeListener(EndpointsEnum.CategoriesOnUpdateCategory, this.onUpdateCategory);
    }

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        const payload: IProcessTakeOffOrderCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: this.props.takeOffOrder.guid,
            category: {
                name: this.state.name,
            },
        };

        this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderCategory, payload);
    };

    createSubCategory = (category: INewCategory, parentCategoryId: number) => {
        const payload: IProcessTakeOffOrderCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: this.props.takeOffOrder.guid,
            category: {
                ...category,
                parent_category_id: parentCategoryId,
            },
        };

        this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderCategory, payload);
    };

    onProcessTakeOffOrderCategory = (data: IOnProcessTakeOffOrderCategoryDTO) => {
        const notification: INotification = {
            message: "successfully_processed_take_off_category",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getTakeOffOrder();
    };

    onUpdateCategory = (data: IOnUpdateCategoryDTO) => {};

    onDeleteCategory = (data: IOnDeleteCategoryDTO) => {
        const notification: INotification = {
            message: "successfully_deleted_take_off_category",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.getTakeOffOrder();
    };

    getTakeOffOrder = () => {
        const payload: IGetTakeOffOrderDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: this.props.takeOffOrder.guid,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffGetTakeOffOrder, payload);
    };

    onGetTakeOffOrder = (data: IOnGetTakeOffOrderDTO) => {
        this.setState({
            takeOffCategories: data.takeOffCategories,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    createCategory = (newCategory: INewCategory) => {
        const payload: IProcessTakeOffOrderCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: this.props.takeOffOrder.guid,
            category: newCategory,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderCategory, payload);

        this.setState({
            name: "",
        });
    };

    updateCategory = (category: ICategory) => {
        const payload: IUpdateCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            categoryGuid: category.guid,
            name: category.name,
        };

        if (category.takeoff_qty) {
            payload.takeoff_qty = category.takeoff_qty;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesUpdateCategory, payload);
    };

    cancelCategory = () => {};

    deleteCategory = (category: ICategory) => {
        const payload: IProcessTakeOffOrderCategoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            takeOffOrderGuid: this.props.takeOffOrder.guid,
            category,
            deleteFlag: true,
        };

        this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOffOrderCategory, payload);
    };

    render() {
        return (
            <div className={"TakeOffOrderCategorySidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} title={"type"} />
                    <hr />
                </div>

                <div className={"mb-3"}>
                    <OwLabel title={"name"} />
                    <div className={"input-group"}>
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.name} />
                        <div className={"input-group-append"}>
                            <OwButton title={"create"} fn={this.create} active={this.state.createActive} disableOnActive={true} />
                        </div>
                    </div>
                </div>

                <div className={"sidebar-content"}>
                    {this.state.takeOffCategories.map((category, index) => {
                        if (category.parent_category_id) {
                            return null;
                        } else {
                            return (
                                <CategoryAccordion
                                    key={category.guid}
                                    createCategoryFn={this.createCategory}
                                    updateCategoryFn={this.updateCategory}
                                    cancelCategoryFn={this.cancelCategory}
                                    deleteCategoryFn={this.deleteCategory}
                                    socket={this.props.socket}
                                    userModel={this.props.userModel}
                                    supplierModel={this.props.supplierModel}
                                    level={0}
                                    category={category}
                                    isSimpleCategories={false}
                                    hideAttributes={true}
                                    hideEmails={true}
                                    hideVendorSources={true}
                                    takeOff={this.props.takeOffOrder}
                                    saveSubCategoryFn={this.createSubCategory}
                                    subCategoryTitle={"subtypes"}
                                    notifyFn={this.props.notifyFn}
                                    index={index}
                                />
                            );
                        }
                    })}
                </div>
            </div>
        );
    }
}

export default TakeOffOrderCategorySidebar;
